export default {
    assistant: {
        welcome: 'Welcome to the sharesuite!',
        yourName: 'Hi! What\'s your name?',
        name: 'Name',
        namePlaceholder: 'First- and surname',
        workFor: 'Who do you work for?',
        company: 'Company',
        companyPlaceholder: 'Sample company',
        moreToCompany: 'More about your company',
        industry: 'Industry',
        industries: {
            retail: 'Retail',
            finance: 'Finance',
            administration: 'Administration',
            healthcare: 'Healthcare',
            law: 'Law',
            media: 'Media',
            technology: 'Technology',
            property: 'Property',
            other: 'Other'
        },
        companySize: 'Company size',
        want: 'I want to...',
        projectManagement: '... manage projects',
        taskManagement: '... create tasks and assign them to employees',
        dmsManagement: '... save and version documents',
        activitiesManagement: '... record activities and book working hours',
        crmManagement: '... save customer contacts and keep them up to date',
        firstProject: 'Create your first project',
        project: 'Project',
        projectPlch: 'e.g. Quality control',
        task: 'What is there to do?',
        taskName: 'Task',
        taskPlch1: 'e.g. Review of production',
        taskPlch2: 'e.g. Approval of production',
        done: 'Done!',
        finished: 'Lets go',
        next: 'Next',
        back: 'Back',
        toStart: 'We have sent you an email with all the information you need to get started on your PC! ' +
            'If you want to use sharesuite on your smartphone, download the app from one of the app stores.',
        required: 'Required'
    },
    common: {
        male: 'Mr.',
        female: 'Mrs.',
        pleaseChoose: 'Please choose',
        username: 'Username / E-Mail',
        email: 'E-Mail',
        firstname: 'Firstname',
        lastname: 'Lastname',
        login: 'Login',
        rememberMe : 'Remember me?',
        password: 'Password',
        tos: 'GTC',
        dataPrivacy: 'Privacy policy',
        createPassword: 'Enter password',
        confirmPassword: 'Confirm password',
        register: 'Register',
        loginLink: 'I already have an account',
        agb: 'I accept the {tos} and {dataPrivacy}*',
        newsLetter: 'Keep me up to date with news, tips and tricks via e-mail.',

        errors: {
            commonError: 'An error occured.',
            fieldRequired: 'Field is required',
            fieldEmailRequired: 'Please supply a valid E-Mail',
            fieldMinLength: 'Field must have atleast {amount} characters',
            passwordConfirmError: 'Passwords have to be equal',

            userExists: 'User already exists.',
        }
    },
    invitation: {
        helloTextWithContext: 'You have been invited to the workspace {context} for a cooperation with sharesuite. To start, we just need some information and we can start!',
        helloText: 'You have been invited for a cooperation with sharesuite. To start, we just need some information and we can start!',

        errors: {
            passwordConfirmError: 'Passwords have to be identical.',
            userExists: 'User already exists.',
            invitationExpired: 'Invitation has expired.'
        }
    },
    register: {
        helloText: "Welcome to sharesuite",
        start: "Start",
        workspaceName: "What should we call your sharesuite?",
        demoData: 'Start with demo data',
        demoDataHint: "For an easier start you can create fictitious demo data for projects, tasks etc. for your sharesuite.",
        workspaceHelp: "Usually this is the name of the own company or project for which sharesuite is to be used. <br>We call this a workspace and the name can be changed later on.",
        registerText : "To start, we just need some information and we can start!",

        activeSession: {
            title: "Active Session",
            text: "You are already logged in to sharesuite in another tab or window. Please save your open changes.",
            confirm: "OK"
        },

        errors: {
            tokenNotFound: "Your email address could not be verified."
        }
    },

    registerMailSent: {
        header: 'You will receive a confirmation email shortly.',
        text: 'Have not received any mail yet? Please check your spam folder!',
        footer: "Thank you for your registration."
    },

    registerUserExists: {
        header: 'User exists',
        text: 'Your email address is already registered',
        footer: '',
        login: "Login",
        forgotPassword: "Forgot password?"
    },

    registerSuccess: {
        go: 'Start',
        header: 'Congratulations! The registration has been successfully completed!',
        text: 'Enjoy working with sharesuite. If you have any questions, our support team is available at support@sharesuite.com. Visit our homepage to discover sharesuite also for your company! Our app is available for Apple and Android devices in the respective app store!'
    },

    join: {
        helloTextWithContext: 'You have been invited to the workspace {context} for a cooperation with sharesuite. Log in to continue.',
        helloText: 'You have been invited for a cooperation with sharesuite. Log in to continue.',
        registerLink: 'Register a new account',
        forgotPasswordLink: 'Forgot password?',
        joinContextSuccess: 'Successfully joined the context... redirecting to sharesuite',

        errors: {
            invitationUsed: 'Invitation has already been used. Are you already in {context}?',
            alreadyInContext: 'You are already in {context}.',
            invitationInvalidName: 'The entered username does not match the supplied username of the invitation.',
            invitationInvalid: 'Sorry, your invitation is invalid. Please contact the person who invited you.',
            loginFailed: 'Login failed. Please verify your login details.',
            noContextAvailable: 'Login failed. There is no workspace for your user.'
        }
    },
    login: {
        failedUserLocked: "Login failed. The account has been locked after to many login attempts. Please reset your password."
    },
    requestPasswordReset: {
        helloText: 'Enter your email address to reset your password.',
        joinLink: 'Log in now',
        registerLink: 'Register a new account',
        go: 'Reset password',

        errors: {
            userNotFound: 'User was not found.'
        }
    },
    requestPasswordResetSuccess: {
        header: 'An E-Mail with further instructions has been sent to {email}.',
        text: 'Please check your mailbox for further instructions on how to reset your password and log into sharesuite.'
    },
    resetPassword: {
        text: 'Please supply a new secure password for your sharesuite account.',

        errors: {
            tokenExpired: 'Your password reset request has expired. Please send a new request.'
        }
    },
    resetPasswordSuccess: {
        header: 'Your password has been reset successfully!',
        text: 'You can now log in to sharesuite with your new password.',
        go: 'Log in'
    },

    trialLanding: {
        text: "Thank you for your registration. In a few seconds you will be redirected to your sharesuite..."
    }
};
